import { render, staticRenderFns } from "./CardPackage.vue?vue&type=template&id=b3b3e2e4&scoped=true"
import script from "./CardPackage.vue?vue&type=script&lang=js"
export * from "./CardPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b3e2e4",
  null
  
)

export default component.exports